type FileFieldAllowlist = {
  allowedTypes?: readonly string[] | null;
  validation?: ({
    allowedTypes?: readonly string[] | null;
  } & Record<string, unknown>) | null;
};

export const DEFAULT_FILE_ALLOWED_TYPES = Object.freeze([
  '.pdf', '.txt', '.png', '.jpg', '.jpeg', '.docx', '.xlsx', '.pptx'
]);

export const withDefaultFileAllowedTypes = <T extends { type?: string }>(field: T): T => {
  const candidate = field as T & FileFieldAllowlist;
  if (candidate.type !== 'file' ||
      candidate.validation?.allowedTypes != null ||
      candidate.allowedTypes != null) {
    return field;
  }

  return { ...field, allowedTypes: [...DEFAULT_FILE_ALLOWED_TYPES] } as T;
};
